import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

const AddControl = React.forwardRef(({ asSpan, children, className, ...props }, ref) => {
  props = { className: classNames('add-control text-primary clickable', className), ref, ...props };

  if (asSpan) {
    return <span {...props}>+ {children}</span>;
  } else {
    return <a {...props}>+ {children}</a>;
  }
});

AddControl.propTypes = {
  asSpan: PropTypes.bool,
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};

export default AddControl;
